import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Check, ArrowRight } from "lucide-react";

export default function Packages() {
  const [pkgs, setPkgs] = useState([]);

  useEffect(() => {
    api
      .get("/packages")
      .then((r) => setPkgs(r.data))
      .catch(() => setPkgs([]));
  }, []);

  return (
    <section id="pacchetti" data-testid="packages-section" className="py-24 sm:py-32 bg-graphite-900/40">
      <div className="container-x">
        <div className="mb-16 max-w-3xl">
          <div className="overline mb-4">Pacchetti trasparenti</div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tighter">
            Prezzi chiari.
            <br />
            <span className="text-white/40">Nessuna sorpresa.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {pkgs.map((p) => (
            <article
              key={p.id}
              data-testid={`package-card-${p.id}`}
              className={`relative flex flex-col p-8 md:p-10 rounded-xl border transition-all duration-300 hover:-translate-y-1 ${
                p.highlighted
                  ? "border-gold bg-gradient-to-b from-gold/10 to-transparent"
                  : "border-white/10 bg-graphite-900 hover:border-white/25"
              }`}
            >
              {p.highlighted && (
                <span className="absolute top-6 right-6 text-[10px] font-bold uppercase tracking-widest bg-gold text-graphite-950 px-3 py-1 rounded-full">
                  Consigliato
                </span>
              )}
              <h3 className="font-display text-2xl font-medium">{p.title}</h3>
              <p className="text-white/50 text-sm mt-2 min-h-[44px]">{p.subtitle}</p>
              <div className="mt-6 flex items-baseline gap-2">
                <span className="font-display text-5xl font-semibold">€{p.price}</span>
                <span className="text-white/40 text-sm">/ progetto</span>
              </div>
              <ul className="mt-8 space-y-3 flex-1">
                {p.features?.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-sm text-white/80">
                    <Check strokeWidth={2} className="w-4 h-4 text-gold mt-0.5 shrink-0" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
              <a
                href="#preventivo"
                data-testid={`package-cta-${p.id}`}
                className={`mt-10 inline-flex items-center gap-2 text-sm font-semibold ${
                  p.highlighted ? "text-gold" : "text-white"
                } hover:gap-3 transition-all`}
              >
                Scegli questo pacchetto
                <ArrowRight strokeWidth={1.5} className="w-4 h-4" />
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
